import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AccessItem from './access-item'
import ResponsiveModal from 'common/components/modules/responsive-modal';
import Icon from 'common/components/elements/icons';
import { isEqual } from 'lodash'
import './style.scss'
import WarningModal from 'common/components/modules/chat/content-warning-modal';
import cx from 'classnames';
import { IncludActiveMembersText, IncludInActiveMembersText } from 'admin/views/multi-access';
import ConfirmModal from 'common/components/modules/modal-wrapper';

const EditMultiAccessModal = ({
   title,
   isDiferent,
   onCloseModal,
   state,
   data,
   onChangeAccess,
   memberType,
   maxPrice,
   defaultNewAccess,
   initialAccess,
   contentType,
   // statistics,
   isActiveMember,
   getStatistics,
   initalDifferent,
   isMobile,
   cancelChackbox,
   showPrerelease,
   showDownload,
   discardModalState,
   showNewStyles,
   modalheaderText,
   highestMembershipId,
   isDownloadDisabled,
   disabledDownloadTooltipText,
}) => {
   const allowedTypesForMedia = ['video', 'photoset', 'live_stream', 'store'];
   const isMedia = allowedTypesForMedia.includes(contentType);

   let width = '420px'
   let height = 'auto'

   if(isDiferent){
      if('members' === memberType) {
         width = 'calc(100% - 88px)'
         height = 'auto'
      } else {
         width = '904px'
         height = 'auto'
      }
   }
   const [newAccess, setNewAccess] = useState(defaultNewAccess)
   const [isDisabled, setIsDisabled] = useState(!initalDifferent)
   const [isUnlockPriceError, setIsUnlockPriceError] = useState(false)
   const [isLimitError, setIsLimitError] = useState(false)
   const [isDownloadPriceError, setIsDownloadPriceError] = useState(false)
   const [openWarningModal, setOpenWarningModal] = useState(false)
   const [isPriceMinLimit, setIsPriceMinLimit] = useState(false)
   const [openDiscardModal, setOpenDiscardModal] = useState(false)

   const onChange = (data, id) => {
      let newData = {
         ...newAccess,
      }
      if('locked' === data.type || 'unlocked' === data.type){
         const prefix = `for_${ data.type }`
         let downloadPrice = 10;
         let preReleasPrice = 10;
         let unlockPrice = 'locked' === data.type  ? data.unlock_price : 10;

         let preReleasAvailable = data[`pre_release_available_${ prefix }`];
         let downloadAvailable = data[`download_available_${ prefix }`];
         let downloadIsFree = data[`download_is_free_${ prefix }`];

         if(!!downloadAvailable && !downloadIsFree){
            downloadPrice = data[`download_price_${ prefix }`];
         }
         if(showPrerelease && preReleasAvailable){
            preReleasPrice = data[`pre_release_price_${ prefix }`];
         }
         const warningModal = setWarningModal(downloadPrice, unlockPrice, preReleasPrice)
         setIsPriceMinLimit(warningModal)
      } else {
         setIsPriceMinLimit(false)
      }
      if(isDiferent) {
         let key = id || 'free';
         newData = {
            ...newData,
            [key]: {
               ...newAccess[key],
               ...data,
            },

         }
         setNewAccess(newData)
      } else {
         newData = {
            ...newData,
            ...data,
         }
         setNewAccess(newData)
      }

      let equal = isEqual(newData, defaultNewAccess)
      setIsDisabled(equal || !!isUnlockPriceError || !!isDownloadPriceError || !!isLimitError)
   }

   const priceValidation = (price, bool, checkDownloadPrice, type) => {
      if(price === '') return true
      if(typeof price !== 'number') return !bool;
      let maxPriceValue = maxPrice.price;
      if(checkDownloadPrice && !!maxPrice.download) {
         maxPriceValue = maxPrice.download
      }
      if(type && maxPrice?.[type]){
         maxPriceValue = maxPrice[type]
      }
      let minPrice = 0;

      if(isMedia){
         minPrice = 0.25;
      } else if('chat' === contentType) {
         minPrice = 0.05;
         if('price_for_text_message' === type){
            minPrice = 0;
         }
      }

      if(contentType === 'store') {
         minPrice = maxPrice.minPrice
      }

      return price < minPrice || price > maxPriceValue;
   }
   const setWarningModal = (price1, price2, price3) => {
      const dontShow = +localStorage.getItem(`dont_show_${ contentType }_multiple_access_coast_warning_modal`)
      if(dontShow) {
         return false
      }
      let minPrice = 0;
      if(isMedia){
         minPrice = 0.25;
      } else if('chat' === contentType) {
         minPrice = 0.05
      }
      return (price1 >= minPrice && price1 < 4) || (price2 >= minPrice && price2 < 4) || (price3 >= minPrice && price3 < 4)

   }

   const checkWrongPriceForMedia = access => {
      let isWrongUnlock = false;
      let isWrongDownload = false;
      if('locked' === access.type || 'unlocked' === access.type){
         // let preReleasePriceValidation = priceValidation(access[`pre_release_price_for_${ access.type }`]);
         let preReleasePriceValidation = false;
         if(`pre_release_price_for_${ access.type }` in access) {
            preReleasePriceValidation = priceValidation(access[`pre_release_price_for_${ access.type }`])
         } else {
            access[`pre_release_price_for_${ access.type }`] = 10;
            access[`pre_release_available_for_${ access.type }`] = false;
         }
         if('locked' === access.type && (priceValidation(access.unlock_price) || (showPrerelease && preReleasePriceValidation))) {
            isWrongUnlock = true
         }
         if('unlocked' === access.type && showPrerelease && preReleasePriceValidation){
            if(access.type === 'unlocked' && 0 === +access.pre_release_price_for_unlocked){
               isWrongUnlock = false
            } else {
               isWrongUnlock = true
            }
         }
         const downloadPrefix = `for_${ access.type }`
         let price = access[`download_price_${ downloadPrefix }`]
         if(priceValidation(price, false, true)) {
            isWrongDownload = true
         }
      }
      return { isWrongUnlock, isWrongDownload }
   }


   const checkVoiceLimitValidation = (access) => {
      let type = access.type;
      if(type === 'off') {
         return true;
      }
      if(type === 'on') {
         type = 'free';
      }
      const key = `max_voice_message_duration_limit_for_${ type }`;
      const limit = access?.[key] || 0;
      return limit > 0 && limit < 601;
   }

   const onClickSave = newAccess => {
      const defaultIndex = Object.keys(newAccess) ? Object.keys(newAccess)[0] : 0;
      let isWrongDownload = isDownloadPriceError
      let isWrongUnlock = isUnlockPriceError
      let isWrongLimit = isLimitError
      setIsDisabled(true)
      // let warningModal = false
      switch (contentType) {
         case 'video':
         case 'photoset':
            if(!isDiferent){
               const result = checkWrongPriceForMedia(newAccess);
               isWrongDownload = result.isWrongDownload
               isWrongUnlock = result.isWrongUnlock
            } else {
               if('others' === memberType){
                  let expired = newAccess.expired;
                  const result = checkWrongPriceForMedia(expired);
                  isWrongDownload = result.isWrongDownload;
                  isWrongUnlock = result.isWrongUnlock;
                  if(result.isWrongDownload || result.isWrongUnlock){
                     isWrongDownload = result.isWrongDownload;
                     isWrongUnlock = result.isWrongUnlock;
                  } else {
                     let guest = newAccess.guest;
                     const result = checkWrongPriceForMedia(guest);
                     isWrongDownload = result.isWrongDownload;
                     isWrongUnlock = result.isWrongUnlock;
                  }
               }
               if('members' === memberType){
                  for(let index = defaultIndex; index < Object.keys(newAccess).length; index++) {
                     const key = Object.keys(newAccess)[index];
                     let elm = newAccess[key];
                     const result = checkWrongPriceForMedia(elm);
                     isWrongDownload = result.isWrongDownload
                     isWrongUnlock = result.isWrongUnlock
                     if(isWrongDownload) break;
                     if(isWrongUnlock) break;
                  }
               }
            }
            break;
         case 'live_stream':
         case 'store':
            if(!isDiferent){
               isWrongUnlock = false;
               isWrongDownload = false;
               if('locked' === newAccess.type && priceValidation(newAccess.unlock_price)){
                  isWrongUnlock = true;
               }
            } else {
               isWrongUnlock = false;
               isWrongDownload = false;
               if('others' === memberType){
                  let expired = newAccess.expired;
                  if(expired && 'locked' === expired.type && priceValidation(expired.unlock_price)){
                     isWrongUnlock = true
                  } else {
                     let guest = newAccess.guest;
                     if(guest && 'locked' === guest.type && priceValidation(guest.unlock_price)){
                        isWrongUnlock = true
                     }
                  }
               }
               if('members' === memberType){
                  for(let index = defaultIndex; index < Object.keys(newAccess).length; index++) {
                     const key = Object.keys(newAccess)[index];
                     let elm = newAccess[key];
                     if(elm && 'locked' === elm.type && priceValidation(elm.unlock_price)){
                        isWrongUnlock = true;
                     }
                  }
               }
            }
            break;
         case 'chat':
            if(!isDiferent){
               // const invalidPrice = (priceValidation(newAccess.price_for_text_message) || priceValidation(newAccess.price_for_voice_message_for_payed) || priceValidation(newAccess.price_for_photo_message_for_payed))
               const invalidPrice =  (priceValidation(newAccess.price_for_voice_message_for_payed) || priceValidation(newAccess.price_for_photo_message_for_payed))
               if(!checkVoiceLimitValidation(newAccess)){
                  isWrongLimit = true
               }
               if('payed' === newAccess.type && invalidPrice){
                  isWrongUnlock = true
               }
            } else {
               if('others' === memberType){
                  let expired = newAccess.expired;
                  const invalidPrice = (priceValidation(expired.price_for_voice_message_for_payed) || priceValidation(expired.price_for_photo_message_for_payed))
                  if(!checkVoiceLimitValidation(expired)){
                     isWrongLimit = true
                  }
                  if(expired && 'payed' === expired.type && invalidPrice){
                     isWrongUnlock = true
                  } else {
                     let guest = newAccess.guest;
                     const invalidPrice =  (priceValidation(guest.price_for_voice_message_for_payed) || priceValidation(guest.price_for_photo_message_for_payed))
                     if(!checkVoiceLimitValidation(guest)){
                        isWrongLimit = true
                     }
                     if(guest && 'payed' === guest.type && invalidPrice){
                        isWrongUnlock = true
                     }
                  }
               }
               if('members' === memberType){
                  for(let index = defaultIndex; index < Object.keys(newAccess).length; index++) {
                     let elm = newAccess[index];
                     const invalidPrice = elm && (priceValidation(elm.price_for_voice_message_for_payed) || priceValidation(elm.price_for_photo_message_for_payed))
                     if(elm && !checkVoiceLimitValidation(elm)){
                        isWrongLimit = true
                     }
                     if(elm && 'payed' === elm.type && invalidPrice){
                        isWrongUnlock = true
                        break
                     }
                  }
               }
            }
            break;

         default:
            isWrongUnlock = false;
            isWrongDownload = false;
            isWrongLimit = false;
            break;
      }

      setIsDownloadPriceError(isWrongDownload)
      setIsUnlockPriceError(isWrongUnlock)
      setIsLimitError(isWrongLimit)
      if(!isWrongUnlock && !isWrongDownload && !isWrongLimit){
         if(isPriceMinLimit){
            setOpenWarningModal(true)
         } else {
            onChangeAccess(newAccess, () => {
               setIsDisabled(false)
            })
         }
      } else {
         setIsDisabled(true)
      }
   }
   const setError = (name, value) => {
      if('unlock' === name) setIsUnlockPriceError(value);
      if('download' === name) setIsDownloadPriceError(value);
      if('limit' === name) setIsLimitError(value);

   }
   let statistics = {}
   if(!isDiferent) {
      statistics = getStatistics()
   }
   // let modalTitle = 'Edit settings'
   // if(isDiferent) {
   //    modalTitle = 'members' === memberType ? 'Add membership settings' : 'Add member type settings'
   // }
   // if(contentType === 'store') {
   //    modalTitle = 'Bundle access settings'
   // }
   return (

      <ResponsiveModal
         headerTitle={ modalheaderText?.modalTitle }
         headerLeftIconAction={ () => {
            let equal = isEqual(newAccess, defaultNewAccess)
            if(equal) {
               onCloseModal()
            } else {
               setOpenDiscardModal(true)

            }
         } }
         onClose={ () => {} }
         width={ width }
         height={ height }
         footerButtonText='Save'
         isDisabled={ isDisabled }
         isLoading={ false }
         foooterButtonAction={ () => onClickSave(newAccess)  }
         contentClass='access-settings-wrapper'
         className={ `${ isDiferent ? 'edit-different-multi-access-modal' : 'edit-multi-access-modal'   } ` }
         isCloseAction={ false }
         showNewStyles={ showNewStyles }
         modalheaderText={ modalheaderText }
         contentInlineStyles={ !isDiferent && contentType === 'store' && memberType === 'members' ? {} : { overflow: 'auto' } }
      >
         <div
            className={ cx({
               'flex flex-wrap multi-access-content': true,
               'multi-others-access-content': 'members' !== memberType && isDiferent,
               'pb-8 px-3': isDiferent,
               'p-6 pt-0': !isDiferent,
               '!px-6': showNewStyles,
            }) }
         >
            {
               isDiferent && Array.isArray(data) && data.map((membership, index) => {
                  // if(cancelChackbox && membership.type === 'free') return null;
                  statistics = getStatistics(membership);
                  let othersMembershipName = null;
                  let title = membership.name;

                  if('expired' === membership.type && contentType !== 'store') {
                     othersMembershipName = 'expired membership';
                     title = `${  membership.name } • ${ membership.expired_members_count }`;
                  }
                  if('guest' === membership.type && contentType !== 'store') {
                     othersMembershipName = 'guest';
                     if('chat' === contentType || 'live_stream_chat' === contentType){
                        title = 'Guest'
                     }
                     else if(contentType === 'mass_message') {
                        title = 'Guests / Subscribers'
                     } else if(contentType === 'poll') {
                        title = 'Guests'
                     }
                     else {
                        title = 'Guest / Visitors'
                     }
                  }
                  if(membership.type === "free") {
                     title = 'Complimentary'
                  }

                  const isHighestMembership = membership.id === highestMembershipId

                  return (
                     <EdistAccessItem
                        key={ membership.id  || membership.type }
                        title={ title }
                        state={ state }
                        access={ membership.access || initialAccess }
                        inputName={ membership.id || membership.type }
                        description={ <MembersPriceInfo
                           contentType={ contentType }
                           isActiveMember={ isActiveMember }
                           statistics={
                              {
                                 usdTerms: membership.usd_terms,
                                 ...statistics,
                                 subscribedMemberCount: contentType === 'mass_message' && 'guest' === membership.type && statistics?.subscribedMemberCount ? statistics.subscribedMemberCount : null,
                              }
                           }
                           isGroup
                        /> }
                        handleChange={ (data) => onChange(data, membership.id || membership.type) }
                        hasCanceldPercentag={ 'members' === memberType &&  !!membership.id }
                        maxPrice={ maxPrice }
                        setError={ setError }
                        isUnlockPriceError={ isUnlockPriceError }
                        isLimitError={ isLimitError }
                        checkVoiceLimitValidation={ checkVoiceLimitValidation }
                        isDownloadPriceError={ isDownloadPriceError }
                        priceValidation={ priceValidation }
                        isMedia={ isMedia }
                        isMoreInfo={ false }
                        isUnpulish={ membership.id ? !membership.is_active : false }
                        isNotAvailable={ membership.id ? !!membership.not_available : false }
                        othersMembershipName={ othersMembershipName }
                        contentType={ contentType }
                        isDiferent={ isDiferent }
                        showDownload={ showDownload }
                        showPrerelease={ showPrerelease }
                        initialAccess={ initialAccess }
                        memberType={ memberType }
                        showNewStyles={ showNewStyles }
                        isHighestMembership={ isHighestMembership }
                        isDownloadDisabled={ isDownloadDisabled }
                        disabledDownloadTooltipText={ disabledDownloadTooltipText }
                     />
                  )
               })
            }
            {
               !isDiferent && (
                  <EdistAccessItem
                     title={ title }
                     description={  <MembersPriceInfo statistics={ statistics } isActiveMember={ isActiveMember } contentType={ contentType } />  }
                     state={ state }
                     access={ data || initialAccess }
                     handleChange={ (data) => onChange(data, null) }
                     inputName=''
                     hasCanceldPercentag={ 'members' === memberType }
                     maxPrice={ maxPrice }
                     setError={ setError }
                     isUnlockPriceError={ isUnlockPriceError }
                     isLimitError={ isLimitError }
                     checkVoiceLimitValidation={ checkVoiceLimitValidation }
                     priceValidation={ priceValidation }
                     isDownloadPriceError={ isDownloadPriceError }
                     isMedia={ isMedia }
                     isMoreInfo={ true }
                     contentType={ contentType }
                     isDiferent={ isDiferent }
                     showPrerelease={ showPrerelease }
                     showDownload={ showDownload }
                     initialAccess={ initialAccess }
                     memberType={ memberType }
                     showNewStyles={ showNewStyles }
                     isDownloadDisabled={ isDownloadDisabled }
                     disabledDownloadTooltipText={ disabledDownloadTooltipText }
                  />
               )
            }
         </div>
         {
            openWarningModal && (
               <WarningModal
                  isMobile={ isMobile }
                  info='Items that cost less than 4.00 USD can be purchased only using the <span class="font-medium">Wallet</span>'
                  actionText='Ok'
                  isCheckbox
                  action={ () => onChangeAccess(newAccess) }
                  closeModal={ () => setOpenWarningModal(false) }
                  dontShowName={ `dont_show_${ contentType }_multiple_access_coast_warning_modal` }
               />
            )
         }
         {
            openDiscardModal && (
               <ConfirmModal
                  type='confirm'
                  icon='cancel'
                  iconColor='error'
                  descriptionColorClass='text-secondary'
                  onCloseModal={ () => setOpenDiscardModal(false)  }
                  title='Discard changes?'
                  description='Changes you have made so far will not be saved'
                  cancelText='Keep editing'
                  nonPrimaryColor
                  contentWidth='375px'
                  isMobile={ isMobile }
                  iconSize='2xl'
                  buttonText='Discard changes'
                  textColor='error'
                  action={ () => onCloseModal() }
                  buttonClassName='mt-8'
               />
            )
         }
      </ResponsiveModal>
   )
}


const EdistAccessItem = ({
   title,
   description,
   state,
   access,
   handleChange,
   inputName,
   hasCanceldPercentag,
   maxPrice,
   setError,
   isUnlockPriceError,
   isDownloadPriceError,
   priceValidation,
   isMedia,
   isMoreInfo,
   isUnpulish,
   othersMembershipName,
   isNotAvailable,
   contentType,
   isDiferent,
   showPrerelease,
   initialAccess,
   memberType,
   showDownload,
   showNewStyles,
   isLimitError,
   checkVoiceLimitValidation,
   isHighestMembership,
   isDownloadDisabled,
   disabledDownloadTooltipText,
}) => {
   const [data, setData] = useState(access)

   useEffect(() => {
      let updateAccess = { ...access };
      for(let key in initialAccess) {
         if(!hasKey(key)){
            updateAccess[key] = initialAccess[key]
         }
      }
      if(!isEqual(updateAccess, access)){
         setData(updateAccess)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const hasKey = (key) => {
      return key in access
   }


   const onChange = (name, value) => {
      if(name === 'pre_release_available_for_locked' || name === 'download_is_free_for_locked'){
         let finalData = {
            ...data,
            [name]: value,
         }
         if(name === 'pre_release_available_for_locked' && isUnlockPriceError
         && priceValidation(data.pre_release_price_for_locked)){
            finalData = {
               ...finalData,
               pre_release_price_for_locked: initialAccess.pre_release_price_for_locked,
            }
         }
         if(name === 'download_is_free_for_locked' && priceValidation(data.download_price_for_locked)){
            finalData = {
               ...finalData,
               download_price_for_locked: initialAccess.download_price_for_locked,
            }
         }

         setData(finalData)
         handleChange(finalData)
         return
      }

      let newData = {
         ...data,
         [name]: value,
      }
      if('unlock_price' === name) {
         newData = {
            ...newData,
            [name]: value !== '' ? value : '',
         }
         if(isUnlockPriceError && priceValidation(data.unlock_price)) {
            setError('unlock', false)
         }
      }
      setData(newData)
      handleChange(newData)
   }

   const onWrongPriceLength = (value, isDownload, type) => {
      const { download } = maxPrice;
      let price = maxPrice.price;
      if(contentType === 'store' && value.length < 8) {
         return false
      }
      if(type && maxPrice?.[type]){
         price = maxPrice[type];
      }
      let maxCherecters = price < 100 ? 2 : 3;
      if(price < 10) {
         maxCherecters = 1;
      }
      if(isDownload && !!download) {
         maxCherecters = download < 100 ? 2 : 3;
      }
      if(value.includes('.')) {
         const test = value.split('.');
         if(maxPrice >= 100){
            maxCherecters = test[0] && test[0].length < 4 ? test[0].length + 3 : 6
         } else {
            maxCherecters = test[0] && test[0].length < 3 ? test[0].length + 3 : 5
         }
      }
      if(value.length > maxCherecters) {
         return true
      }
      return false
   }
   return (
      <div className='flex flex-col access-card'>
         <div className='flex items-center'>
            {/* notranslate-content-title */}
            <span className='text-base leading-[19px] flex-wrap font-semibold text-major mb-1 flex items-center notranslate'>{title}
               {
                  isNotAvailable && <span className='text-secondary'>&nbsp;(Not available)</span>
               }
               {
                  isUnpulish && !isNotAvailable && <span className='text-secondary'>&nbsp;(Unpublished)</span>
               }
               {/* {
                  showNewStyles &&
                  // <Icon name={ `help-outline` } size='xl' className={ `ml-2 mb-1 ` } color='placeholder' />
               } */}
            </span>
         </div>

         {description && description}
         <div className='flex flex-col box-border border border-divider bg-panel rounded-btn mt-2'>
            {
               Object.keys(state).map((key, index) => {

                  if(contentType === 'store' && !isDiferent && key === 'not_available' && 'members' === memberType) {
                     // eslint-disable-next-line array-callback-return
                     return
                  }

                  if(contentType === 'store' && isDiferent && key === 'not_available' && 'members' === memberType && isHighestMembership) {
                     // eslint-disable-next-line array-callback-return
                     return
                  }

                  if(isDiferent && key === 'not_available' && 'members' === memberType && 'free' === inputName) {
                     return null
                  }

                  return (
                     <AccessItem
                        key={ index.toString() }
                        isActive={ data.type === key }
                        data={ state[key] }
                        onChange={ (name, value) => {
                           if(!!name){
                              onChange(name, value)
                           } else {
                              onChange('type', key)
                           }
                        } }
                        contentType={ contentType }
                        inputName={ inputName }
                        hasCanceldPercentag={ hasCanceldPercentag }
                        access={ data }
                        maxPrice={ maxPrice }
                        setError={ setError }
                        isPriceError={ isUnlockPriceError }
                        onWrongPriceLength={ onWrongPriceLength }
                        priceValidation={ priceValidation }
                        isLimitError={ isLimitError }
                        checkVoiceLimitValidation={ checkVoiceLimitValidation }
                        isMedia={ isMedia }
                        isDownloadPriceError={ isDownloadPriceError }
                        othersMembershipName={ 'not_available' === key ? othersMembershipName : null }
                        isDiferent={ isDiferent }
                        showPrerelease={ showPrerelease }
                        showDownload={ showDownload }
                        memberType={ memberType }
                        showNewStyles={ showNewStyles }
                        isDownloadDisabled={ isDownloadDisabled }
                        disabledDownloadTooltipText={ disabledDownloadTooltipText }
                     />

                  )
               })
            }
         </div>
      </div>
   )
}

const MembersPriceInfo = ({
   isGroup,
   statistics,
   isActiveMember,
   contentType,
}) => {
   if(!isGroup) {
      const {
         activeMemberCount,
         expiredMemberCount,
         guestMemberCount,
         cancelledMemberCount,
         freeMemberCount,
         subscribedMemberCount,
      } = statistics
      return (
         <>
            {
               isActiveMember && (
                  <IncludActiveMembersText
                     activeMemberCount={ activeMemberCount }
                     cancelledMemberCount={ cancelledMemberCount }
                     freeMemberCount={ freeMemberCount }
                  />
               )
            }
            {
               !isActiveMember && (
                  <IncludInActiveMembersText
                     expiredMemberCount={ expiredMemberCount }
                     guestMemberCount={ guestMemberCount }
                     subscribedMemberCount={ subscribedMemberCount }
                     isVisitor={ !['mass_message', 'live_stream_chat', 'chat', 'store', 'poll'].includes(contentType) }
                  />
               )
            }
         </>

      )
   }
   const {
      activeMemberCount,
      cancelledMemberCount,
      usdTerms,
      guestMemberCount,
      expiredMemberCount,
      subscribedMemberCount,
   } = statistics
   return (
      <div className='flex flex-col gap-2'>
         <div className='flex items-center gap-1'>
            {
               isActiveMember && (
                  <div
                     className='flex  items-center justify-center'>
                     <Icon name='membership' color='secondary' size='lg' />
                  </div>
               )
            }
            {
               isActiveMember  && (
                  <span className='panel-description text-secondary'>
                     {
                        activeMemberCount && (
                           <>
                              {activeMemberCount}<span className='font-bold'>&nbsp;active</span>
                           </>
                        )
                     }
                     {
                        activeMemberCount && cancelledMemberCount && ', '
                     }
                     {
                        cancelledMemberCount &&
                     (
                        <>{cancelledMemberCount}<span className='font-bold'>&nbsp;cancelled</span></>
                     )
                     }

                  </span>
               )
            }
            {
               !isActiveMember && (guestMemberCount || subscribedMemberCount) && (
                  <>
                     <span className='text-xs text-secondary'>
                        Includes&nbsp;
                        {
                           guestMemberCount && (
                              <>
                                 {guestMemberCount} guest members
                              </>
                           )
                        }

                        {
                           guestMemberCount && subscribedMemberCount && <>&nbsp;and</>
                        }
                        {
                           subscribedMemberCount && (
                              <>
                                 &nbsp;{subscribedMemberCount} subscribers
                              </>
                           )
                        }
                     </span>
                  </>
               )
            }
            {
               !isActiveMember && expiredMemberCount && (
                  <span className='text-xs text-secondary'>
                     Membership has expired
                  </span>
               )
            }
         </div>
         {
            usdTerms && (
               <div className='flex items-center gap-1'>
                  <div
                     className=' flex  items-center justify-center'>
                     <Icon name='money' color='secondary' size='lg' />
                  </div>
                  <span className='text-xs text-secondary'>{usdTerms}</span>
               </div>
            )}
      </div>
   )
}

EditMultiAccessModal.defaultProps = {
   discardModalState: {},
   showNewStyles: false,
   // discardModalState: {},
   highestMembershipId: null,
}

EditMultiAccessModal.propTypes = {
   title: PropTypes.string,
   state: PropTypes.object,
   isDiferent: PropTypes.bool,
   onCloseModal: PropTypes.func,
   data: PropTypes.any,
   onChangeAccess: PropTypes.func,
   memberType: PropTypes.string,
   maxPrice: PropTypes.object,
   defaultNewAccess: PropTypes.object,
   initialAccess: PropTypes.object,
   contentType: PropTypes.string,
   getStatistics: PropTypes.func,
   isActiveMember: PropTypes.bool,
   initalDifferent: PropTypes.bool,
   isMobile: PropTypes.bool,
   cancelChackbox: PropTypes.bool,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   discardModalState: PropTypes.object,
   showNewStyles: PropTypes.bool,
   modalheaderText: PropTypes.object,
   // discardModalState: PropTypes.object,
   highestMembershipId: PropTypes.number,
   isDownloadDisabled: PropTypes.bool,
   disabledDownloadTooltipText: PropTypes.string,
}
EdistAccessItem.propTypes = {
   title: PropTypes.string,
   description: PropTypes.any,
   state: PropTypes.object,
   access: PropTypes.object,
   handleChange: PropTypes.func,
   inputName: PropTypes.any,
   hasCanceldPercentag: PropTypes.bool,
   maxPrice: PropTypes.object,
   setError: PropTypes.func,
   isUnlockPriceError: PropTypes.bool,
   isDownloadPriceError: PropTypes.bool,
   priceValidation: PropTypes.func,
   isMoreInfo: PropTypes.bool,
   isUnpulish: PropTypes.bool,
   isMedia: PropTypes.bool,
   isNotAvailable: PropTypes.bool,
   othersMembershipName: PropTypes.string,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   contentType: PropTypes.string,
   isDiferent: PropTypes.bool,
   initialAccess: PropTypes.object,
   memberType: PropTypes.string,
   showNewStyles: PropTypes.bool,
   isLimitError: PropTypes.bool,
   checkVoiceLimitValidation: PropTypes.func,
   isHighestMembership: PropTypes.number,
   isDownloadDisabled: PropTypes.bool,
   disabledDownloadTooltipText: PropTypes.string,
}
MembersPriceInfo.propTypes = {
   statistics: PropTypes.object,
   isActiveMember: PropTypes.bool,
   contentType: PropTypes.string,
   usdTerms: PropTypes.string,
   isGroup: PropTypes.bool,
}

export default EditMultiAccessModal;
